import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { AnimatedText } from './AnimatedText';
export function ContactSection() {
  const inputVariants = {
    focus: {
      scale: 1.02,
      transition: {
        duration: 0.3
      }
    }
  };
  return <section id="contact" className="py-20 bg-gray-50" data-id="element-75">
      <div className="container mx-auto px-4" data-id="element-76">
        <AnimatedSection className="text-center mb-12" data-id="element-77">
          <AnimatedText text="Contact Us" className="text-3xl md:text-4xl font-bold mb-4" as="h2" data-id="element-78" />
          <motion.p className="text-lg text-gray-600 max-w-2xl mx-auto" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} data-id="element-79">
            Get in touch with the Solochus Group team to learn more about our
            companies or discuss business opportunities.
          </motion.p>
        </AnimatedSection>
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-80">
          <AnimatedSection delay={0.2} className="lg:w-1/2" data-id="element-81">
            <motion.form className="bg-white p-8 rounded-lg shadow-md" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} data-id="element-82">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-83">
                <div data-id="element-84">
                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-85">
                    First Name
                  </label>
                  <motion.input type="text" id="firstName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" placeholder="Your first name" whileFocus="focus" variants={inputVariants} data-id="element-86" />
                </div>
                <div data-id="element-87">
                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-88">
                    Last Name
                  </label>
                  <motion.input type="text" id="lastName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" placeholder="Your last name" whileFocus="focus" variants={inputVariants} data-id="element-89" />
                </div>
              </div>
              <div className="mb-6" data-id="element-90">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-91">
                  Email Address
                </label>
                <motion.input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" placeholder="Your email address" whileFocus="focus" variants={inputVariants} data-id="element-92" />
              </div>
              <div className="mb-6" data-id="element-93">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-94">
                  Subject
                </label>
                <motion.select id="subject" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" whileFocus="focus" variants={inputVariants} data-id="element-95">
                  <option value="" data-id="element-96">Select a subject</option>
                  <option value="general" data-id="element-97">General Inquiry</option>
                  <option value="business" data-id="element-98">Business Opportunity</option>
                  <option value="career" data-id="element-99">Career Information</option>
                  <option value="media" data-id="element-100">Media Inquiry</option>
                  <option value="other" data-id="element-101">Other</option>
                </motion.select>
              </div>
              <div className="mb-6" data-id="element-102">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-103">
                  Message
                </label>
                <motion.textarea id="message" rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" placeholder="Your message" whileFocus="focus" variants={inputVariants} data-id="element-104"></motion.textarea>
              </div>
              <motion.button type="submit" className="w-full py-3 px-4 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors" whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} data-id="element-105">
                Send Message
              </motion.button>
            </motion.form>
          </AnimatedSection>
          <AnimatedSection delay={0.4} className="lg:w-1/2" data-id="element-106">
            <motion.div className="bg-white p-8 rounded-lg shadow-md h-full" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} data-id="element-107">
              <h3 className="text-xl font-bold mb-6" data-id="element-108">
                Our Contact Information
              </h3>
              <div className="space-y-6" data-id="element-109">
                <motion.div className="flex items-start" whileHover={{
                x: 5
              }} transition={{
                duration: 0.2
              }} data-id="element-110">
                  <MapPin className="text-blue-600 mt-1 mr-4 flex-shrink-0" data-id="element-111" />
                  <div data-id="element-112">
                    <h4 className="font-semibold mb-1" data-id="element-113">Headquarters</h4>
                    <p className="text-gray-600" data-id="element-114">
                      123 Corporate Drive
                      <br data-id="element-115" />
                      Lagos, Nigeria
                    </p>
                  </div>
                </motion.div>
                <motion.div className="flex items-start" whileHover={{
                x: 5
              }} transition={{
                duration: 0.2
              }} data-id="element-116">
                  <Phone className="text-blue-600 mt-1 mr-4 flex-shrink-0" data-id="element-117" />
                  <div data-id="element-118">
                    <h4 className="font-semibold mb-1" data-id="element-119">Phone</h4>
                    <p className="text-gray-600" data-id="element-120">
                      +234 123 456 7890
                      <br data-id="element-121" />
                      +234 987 654 3210
                    </p>
                  </div>
                </motion.div>
                <motion.div className="flex items-start" whileHover={{
                x: 5
              }} transition={{
                duration: 0.2
              }} data-id="element-122">
                  <Mail className="text-blue-600 mt-1 mr-4 flex-shrink-0" data-id="element-123" />
                  <div data-id="element-124">
                    <h4 className="font-semibold mb-1" data-id="element-125">Email</h4>
                    <p className="text-gray-600" data-id="element-126">
                      info@solochusgroup.co
                      <br data-id="element-127" />
                      contact@solochusgroup.co
                    </p>
                  </div>
                </motion.div>
              </div>
              <div className="mt-8" data-id="element-128">
                <h4 className="font-semibold mb-4" data-id="element-129">Subsidiary Contacts</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-130">
                  <motion.div className="bg-amber-50 p-3 rounded-md" whileHover={{
                  scale: 1.05,
                  backgroundColor: '#FEF3C7'
                }} transition={{
                  duration: 0.2
                }} data-id="element-131">
                    <h5 className="font-medium mb-1" data-id="element-132">Solochus Palace Hotel</h5>
                    <p className="text-sm text-gray-600" data-id="element-133">
                      hotel@solochusgroup.co
                    </p>
                  </motion.div>
                  <motion.div className="bg-emerald-50 p-3 rounded-md" whileHover={{
                  scale: 1.05,
                  backgroundColor: '#ECFDF5'
                }} transition={{
                  duration: 0.2
                }} data-id="element-134">
                    <h5 className="font-medium mb-1" data-id="element-135">Standard Purity Ent.</h5>
                    <p className="text-sm text-gray-600" data-id="element-136">
                      purity@solochusgroup.co
                    </p>
                  </motion.div>
                  <motion.div className="bg-blue-50 p-3 rounded-md" whileHover={{
                  scale: 1.05,
                  backgroundColor: '#EFF6FF'
                }} transition={{
                  duration: 0.2
                }} data-id="element-137">
                    <h5 className="font-medium mb-1" data-id="element-138">Puritydefine Nig Ltd</h5>
                    <p className="text-sm text-gray-600" data-id="element-139">
                      define@solochusgroup.co
                    </p>
                  </motion.div>
                  <motion.div className="bg-red-50 p-3 rounded-md" whileHover={{
                  scale: 1.05,
                  backgroundColor: '#FEF2F2'
                }} transition={{
                  duration: 0.2
                }} data-id="element-140">
                    <h5 className="font-medium mb-1" data-id="element-141">Unique Buka</h5>
                    <p className="text-sm text-gray-600" data-id="element-142">
                      buka@solochusgroup.co
                    </p>
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}